import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import {
  employeeFormatOptions,
  formatOptions,
  formatOptionString,
} from "./optionsFormatter";
import { useGetGroupsQuery } from "AppQuries/master/Group/group";
import { useGetEmployeeStatusesQuery } from "AppQuries/master/employee-status";
import { useGetAllDesignationQuery } from "AppQuries/master/Designation/get-all-designations";
import { useGetEmploymentTypesQuery } from "AppQuries/master/EmploymentType/employmentType";
import { useGetContractTypesQuery } from "AppQuries/master/ContractType/contract-type";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useGetEmployeeTypesQuery } from "AppQuries/master/employee-type";

export const useFormattedEmployees = ({
  companyCode,
  locationCode,
  departmentCode = 0,
}) => {
  const { data: employees } = useGetEmployeeQuery({
    companyCode: companyCode,
    locationCode: locationCode,
    departmentCode: departmentCode,
  });

  const options = employeeFormatOptions(
    employees,
    "uniqueId",
    "fullName",
    "employeeCode"
  );
  return options;
};

export const useFormattedExcluedEmployeesOptions = ({
  companyCode,
  locationCode,
  departmentCode = 0,
}) => {
  const { data: employees } = useGetEmployeeQuery({
    companyCode: companyCode,
    locationCode: locationCode,
    departmentCode: departmentCode,
  });



  const excluedList = employees?.filter(
    (emp) => emp.excludeTime === "false" || emp.excludeTime === false
  );


  const options = employeeFormatOptions(
    excluedList,
    "uniqueId",
    "fullName",
    "employeeCode"
  );
  return options;
};

export function useFormattedDepartmentOption(companyCode) {
  const { data: departments } = useGetAllDepartmentQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(departments?.data, "description", "code");
  return options;
}

export const useFormattedDesignationOption = (companyCode) => {
  const { data: designations } = useGetAllDesignationQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(designations?.data, "description", "code");
  return options;
};

export const useFormattedEmpGroupOption = (companyCode) => {
  const { data } = useGetGroupsQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(data, "groupName", "groupCode");
  return options;
};

export const useFormattedEmpStatusOption = (companyCode) => {
  const { data } = useGetEmployeeStatusesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(data, "statusName", "statusCode");
  return options;
};

export const useFormattedEmpTypeOption = (companyCode) => {
  const { data } = useGetEmployeeTypesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptionString(data, "typeName", "code");
  return options;
};

export const useFormattedEmpContractOption = (companyCode) => {
  const { data } = useGetContractTypesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptionString(data, "contractName", "contractCode");
  return options;
};

export const useFormattedEmploymentTypeOption = (companyCode) => {
  const { data } = useGetEmploymentTypesQuery({
    companyCode: companyCode,
    isTrue: true,
  });
  const options = formatOptionString(data, "termName", "termCode");
  return options;
};
